var map = {
	"./spaces/counselors/counselors.module.ngfactory": [
		"./app/spaces/counselors/counselors.module.ngfactory.js",
		"spaces-counselors-counselors-module-ngfactory"
	],
	"./spaces/individuals/individuals.module.ngfactory": [
		"./app/spaces/individuals/individuals.module.ngfactory.js",
		"spaces-individuals-individuals-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;